import { render, staticRenderFns } from "./PlanPayModal.vue?vue&type=template&id=5420383f&scoped=true"
import script from "./PlanPayModal.vue?vue&type=script&lang=js"
export * from "./PlanPayModal.vue?vue&type=script&lang=js"
import style0 from "./PlanPayModal.vue?vue&type=style&index=0&id=5420383f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5420383f",
  null
  
)

export default component.exports